module.exports = __webpack_public_path__ + "static/img/5137_phase_function_Paper_PointsHejduk_Prediction.b6c6ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5137_phase_function_Paper_PointsHejduk_Prediction.png
// module id = CoGb
// module chunks = 0